import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import theme, { responsiveFontSize } from "themes/Theme";
import ProfileManagement from "./components/ProfileManagement";
import SecuritySettings from "./components/SecuritySettings";

const ProfileSettingsPage = () => {
  const [selectedTab, setSelectedTab] = useState(Tabs.PROFILE_MANAGEMENT);

  const getContainerStyle = (tab: Tabs) => {
    if (tab === selectedTab) {
      return styles.selectedTab;
    }
    return styles.defaultTab;
  };

  const getTextStyle = (tab: Tabs) => {
    if (tab === selectedTab) {
      return styles.activeTabSelectionText;
    }
    return styles.defaultTabSelectionText;
  };

  return (
    <Box>
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <Box
          sx={getContainerStyle(Tabs.PROFILE_MANAGEMENT)}
          onClick={() => setSelectedTab(Tabs.PROFILE_MANAGEMENT)}
        >
          <Typography sx={getTextStyle(Tabs.PROFILE_MANAGEMENT)}>
            Profile Settings
          </Typography>
        </Box>
        <Box
          sx={getContainerStyle(Tabs.SECURITY_SETTINGS)}
          onClick={() => setSelectedTab(Tabs.SECURITY_SETTINGS)}
        >
          <Typography sx={getTextStyle(Tabs.SECURITY_SETTINGS)}>
            Security Settings
          </Typography>
        </Box>
        {/* <Box
          sx={getContainerStyle(Tabs.PREFERENCES)}
          onClick={() => setSelectedTab(Tabs.PREFERENCES)}
        >
          <Typography sx={getTextStyle(Tabs.PREFERENCES)}>
            Preferences
          </Typography>
        </Box> */}
      </Stack>

      {Tabs.PROFILE_MANAGEMENT === selectedTab && <ProfileManagement />}
      {Tabs.SECURITY_SETTINGS === selectedTab && <SecuritySettings />}
    </Box>
  );
};
export default ProfileSettingsPage;
const styles = {
  selectedTab: {
    backgroundColor: "#FFFFFF",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
    borderRadius: "10px",
    px: 2,
    py: 1,
    "&:hover": {
      cursor: "pointer",
    },
  },
  defaultTab: {
    px: 2,
    py: 1,
    "&:hover": {
      cursor: "pointer",
    },
  },
  defaultTabSelectionText: {
    color: "rgba(153, 153, 153, 1)",
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
  },
  activeTabSelectionText: {
    color: theme.palette.text.primary,
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
  },
};

enum Tabs {
  PROFILE_MANAGEMENT,
  SECURITY_SETTINGS,
  PREFERENCES,
}
